<template>
  <div class="mt-6 -mb-1 flex flex-wrap">
    <template v-for="(link, key) in links">

        <div v-if="link.url === null" :key="'nolink' + key"
            class="mr-1 mb-1 px-3 py-2 text-sm border shadow-md rounded text-gray-400"
            :class="{ 'ml-auto': link.label === 'Next' }"
            v-html="link.label"
        >
        </div>

        <Link v-else :key="key"
            class="mr-1 mb-1 px-3 py-2 text-sm border shadow-md rounded hover:border-primary hover:bg-gray-dark hover:text-white focus:border-primary"
            :class="{ 'bg-gray-dark text-white hover:bg-gray-darker hover:text-white border-none': link.active, 'ml-auto': link.label === 'Next' }"
            :href="link.url"
            v-html="link.label"
        >
        </Link>

    </template>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
    props: {
        links: Array,
    },
    components: {
        Link,
    }
}
</script>
